import script from "./LinkTakenPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkTakenPage.vue?vue&type=script&setup=true&lang=js"

import "./LinkTakenPage.vue?vue&type=style&index=0&id=122cbc26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122cbc26"]])

export default __exports__